import type { AdminNotification } from "@/services/adminNotificationService";

type DayGroup = "today" | "yesterday" | "older";

function dayGroup(value: string): DayGroup {
  const date = new Date(value);
  const now = new Date();
  const startOfToday = new Date(
    now.getFullYear(),
    now.getMonth(),
    now.getDate(),
  );
  const startOfYesterday = new Date(startOfToday);
  startOfYesterday.setDate(startOfYesterday.getDate() - 1);

  if (date >= startOfToday) {
    return "today";
  }
  if (date >= startOfYesterday) {
    return "yesterday";
  }
  return "older";
}

export function groupNotificationsByDay(
  notifications: AdminNotification[],
): { group: DayGroup; items: AdminNotification[] }[] {
  const groups: Record<DayGroup, AdminNotification[]> = {
    today: [],
    yesterday: [],
    older: [],
  };

  for (const notification of notifications) {
    groups[dayGroup(notification.last_occurred_at)].push(notification);
  }

  return (["today", "yesterday", "older"] as const)
    .filter((group) => groups[group].length > 0)
    .map((group) => ({ group, items: groups[group] }));
}
